/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var collection = require('./collection');
var consts = require('./consts');
var extent = require('./extent');
var feature = require('./feature');
var format = require('./format');
var geojson = require('./geojson');
var geom = require('./geom');
var loadStrategy = require('./load-strategy');
var proj = require('./proj');
var style = require('./style');
var tileGrid = require('./tile-grid');
var util = require('./util');

/**
 * @module ol-ext
 */

Object.keys(collection).forEach(function (key) { exports[key] = collection[key]; });
Object.keys(consts).forEach(function (key) { exports[key] = consts[key]; });
Object.keys(extent).forEach(function (key) { exports[key] = extent[key]; });
Object.keys(feature).forEach(function (key) { exports[key] = feature[key]; });
Object.keys(format).forEach(function (key) { exports[key] = format[key]; });
Object.keys(geojson).forEach(function (key) { exports[key] = geojson[key]; });
Object.keys(geom).forEach(function (key) { exports[key] = geom[key]; });
Object.keys(loadStrategy).forEach(function (key) { exports[key] = loadStrategy[key]; });
Object.keys(proj).forEach(function (key) { exports[key] = proj[key]; });
Object.keys(style).forEach(function (key) { exports[key] = style[key]; });
Object.keys(tileGrid).forEach(function (key) { exports[key] = tileGrid[key]; });
Object.keys(util).forEach(function (key) { exports[key] = util[key]; });



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/index.js
// module id = 129
// module chunks = 1